import axios from 'axios'
import { API_URL } from '../api'

export function getWeather(callback) {
	return dispatch => {
		let socketId = null

		if (axios.defaults.headers.common['X-Socket-ID']) {
			socketId = axios.defaults.headers.common['X-Socket-ID']
		}

		delete axios.defaults.headers.common['X-Socket-ID']

		axios.get('https://ipapi.co/json/')
			.then(response => {
				let units = 'ca'

				if (response.data.country == 'US') {
					units = 'us'
				}

				axios.get(`${API_URL}/dashboard/getWeather?lat=${response.data.latitude}&lng=${response.data.longitude}&units=${units}`).then(weatherData => {
					callback({
						...weatherData.data.currently,
						format: units
					})
				}).catch(error => {
					console.log(error)
				})
			})

		axios.defaults.headers.common['X-Socket-ID'] = socketId
	}
}

export function getDashboardData(accountId, callback, token = null) {
	if (token) {		
		axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
	}

	return dispatch => {
		axios.get(API_URL + '/dashboard?id=' + accountId).then(response => {
			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: response.data,
				entityType: 'dashboardData',
			})

			callback()
		})
	}
}

export const togglePreference = (user, type) => {
	return dispatch => {
		const key = type+'_toggled'

		axios.post(API_URL+'/user/togglePreference', { 
			toggled: !user[key],
			key
		}).catch(error => {
			console.log(error)
		})

		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: {
				...user,
				[key]: !user[key]
			},
			entityType: 'user',
		})
	}
}

export function getAllProjectProgress(accountId, offset) {
	return dispatch => {
		axios.get(API_URL + '/dashboard/getAllProgress?id='+accountId+'&offset='+offset).then(response => {
			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: response.data,
				entityType: 'project',
				isArray: true
			})
		})
	}
}

export const dashboardQuery = (id, type, callback) => {
	return dispatch => {
		axios.post(API_URL+'/dashboard/query', { id, type })
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'dashboardQuery',
				})

				callback()
			})
	}
}

export const getTimeTrackingTotals = (projectId, callback) => {
	return dispatch => {
		axios.get(API_URL+'/dashboard/timeTrackingTotals/'+projectId)
			.then(response => {
				if(callback){
					callback(response.data)
				}
			})
			.catch(error => {
				console.log(error)
			})
	}
}


// WEBPACK FOOTER //
// ./src/state/actions/dashboard-actions.jsx